import { Chip } from '@mui/material';
import { ExampleBox, StyledContainer } from '../styled';

const LabelsDemoSection = () => (
  <>
    <StyledContainer>
      <h1>Labels</h1>
      <p>
        Labels are currently used to display meta data for a track, as well as
        to highlight a specific feature that is new within the product. We need
        2 styles for this, solid and outlined. We also need the ability to
        change the colour for specific labels.
      </p>
      <p>Examples:</p>
      <ExampleBox>
        <Chip variant="filled" color="secondary" label="Label Lilac Filled" />
        <Chip
          variant="outlined"
          color="secondary"
          label="Label Lilac Outlined"
        />
        <Chip variant="outlined" label="Label Grey Outlined" />
        <Chip variant="filled" label="Label Grey Filled" />
      </ExampleBox>
      <p>
        Example of labels to display meta data of tracks generated using vega:
      </p>
      <ExampleBox>
        <Chip variant="outlined" label="Ambient House" />
        <Chip variant="outlined" label="3:25" />
        <Chip variant="outlined" label="60 BPM" />
        <Chip variant="outlined" label="Low Energy" />
        <Chip variant="outlined" label="Synth" />
      </ExampleBox>
      <p>Example of labels with different colors:</p>
      <ExampleBox>
        <Chip variant="outlined" label="Default" />
        <Chip variant="outlined" color="primary" label="Primary" />
        <Chip variant="outlined" color="secondary" label="Secondary" />
        <Chip variant="outlined" color="success" label="Success" />
        <Chip variant="outlined" color="error" label="Error" />
        <Chip variant="outlined" color="warning" label="Warning" />
        <Chip variant="outlined" color="info" label="Info" />
      </ExampleBox>
      <p>Example of a label to display a new feature:</p>
      <ExampleBox>
        <Chip variant="filled" color="secondary" label="NEW" />
      </ExampleBox>
    </StyledContainer>
  </>
);

export default LabelsDemoSection;
